package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.Accent
import com.merkost.handpass.sharedweb.theme.ActionAccent
import com.merkost.handpass.sharedweb.theme.ActionAccentHover
import com.merkost.handpass.sharedweb.theme.ActionAccentPressed
import com.merkost.handpass.sharedweb.theme.AnimNames
import com.merkost.handpass.sharedweb.theme.Border
import com.merkost.handpass.sharedweb.theme.BorderStrong
import com.merkost.handpass.sharedweb.theme.ButtonGap
import com.merkost.handpass.sharedweb.theme.ButtonLgPadH
import com.merkost.handpass.sharedweb.theme.ButtonLgPadV
import com.merkost.handpass.sharedweb.theme.ButtonLgSpinner
import com.merkost.handpass.sharedweb.theme.ButtonLgType
import com.merkost.handpass.sharedweb.theme.ButtonMdPadH
import com.merkost.handpass.sharedweb.theme.ButtonMdPadV
import com.merkost.handpass.sharedweb.theme.ButtonMdSpinner
import com.merkost.handpass.sharedweb.theme.ButtonMdType
import com.merkost.handpass.sharedweb.theme.ButtonSmPadH
import com.merkost.handpass.sharedweb.theme.ButtonSmPadV
import com.merkost.handpass.sharedweb.theme.ButtonSmSpinner
import com.merkost.handpass.sharedweb.theme.ButtonSmType
import com.merkost.handpass.sharedweb.theme.Danger
import com.merkost.handpass.sharedweb.theme.DangerSoft
import com.merkost.handpass.sharedweb.theme.Dur
import com.merkost.handpass.sharedweb.theme.Ease
import com.merkost.handpass.sharedweb.theme.OnActionAccent
import com.merkost.handpass.sharedweb.theme.OnBrandActionAccent
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.OnSurfaceMuted
import com.merkost.handpass.sharedweb.theme.RadiusButton
import com.merkost.handpass.sharedweb.theme.Shadow
import com.merkost.handpass.sharedweb.theme.Success
import com.merkost.handpass.sharedweb.theme.SuccessSoft
import com.merkost.handpass.sharedweb.theme.Surface
import com.merkost.handpass.sharedweb.theme.SurfaceMuted
import com.merkost.handpass.sharedweb.theme.TouchTarget
import com.merkost.handpass.sharedweb.theme.Transparent
import com.merkost.handpass.sharedweb.theme.WebIconSize
import com.merkost.handpass.sharedweb.theme.WebMotion
import com.merkost.handpass.sharedweb.theme.WebSize
import com.merkost.handpass.sharedweb.theme.transitionSurface
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.disabled as disabledSelector
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLButtonElement

enum class WebButtonVariant { Primary, Brand, Secondary, Outline, Destructive, Ghost, Bare, Ok }

enum class WebButtonSize { SM, MD, LG }

val WebButtonBaseStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.LegacyInlineFlex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .gap(ButtonGap.value())
            .fontWeight(600)
            .borderRadius(RadiusButton.value())
            .border(WebSize.P1.value(), LineStyle.Solid, Transparent.value())
            .cursor(Cursor.Pointer)
            .minHeight(TouchTarget.value())
            .transitionSurface()
            .styleModifier {
                property("white-space", "nowrap")
                property("flex-shrink", "0")
                property("max-width", "100%")
                property("overflow", "hidden")
                property("text-overflow", "ellipsis")
                property("font-family", "inherit")
                property("letter-spacing", "0")
            }
    }
    active {
        Modifier.scale(WebMotion.PressScale)
    }
    focusVisible {
        Modifier
            .outline(WebSize.P2.value(), LineStyle.Solid, OnSurface.value())
            .styleModifier { property("outline-offset", WebSize.P2.value().toString()) }
    }
    disabledSelector {
        Modifier
            .opacity(0.5)
            .cursor(Cursor.NotAllowed)
    }
}

val WebButtonPrimaryStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(ActionAccent.value())
            .color(OnActionAccent.value())
    }
    hover { Modifier.backgroundColor(ActionAccentHover.value()) }
    active { Modifier.backgroundColor(ActionAccentPressed.value()) }
}

val WebButtonBrandStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Accent.value())
            .color(OnBrandActionAccent.value())
    }
    hover {
        Modifier
            .backgroundColor(Accent.value())
            .styleModifier { property("box-shadow", Shadow.CardHover) }
    }
    active {
        Modifier
            .backgroundColor(Accent.value())
            .styleModifier { property("box-shadow", Shadow.Card) }
    }
}

val WebButtonSecondaryStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Surface.value())
            .color(OnSurface.value())
            .border { color(Border.value()) }
    }
    hover {
        Modifier
            .backgroundColor(SurfaceMuted.value())
            .border { color(BorderStrong.value()) }
    }
}

val WebButtonOutlineStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Transparent.value())
            .color(OnSurface.value())
            .border { color(BorderStrong.value()) }
    }
    hover { Modifier.backgroundColor(SurfaceMuted.value()) }
}

val WebButtonDestructiveStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Transparent.value())
            .color(Danger.value())
            .border { color(Border.value()) }
    }
    hover {
        Modifier
            .backgroundColor(DangerSoft.value())
            .border { color(Danger.value()) }
    }
}

val WebButtonGhostStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Transparent.value())
            .color(OnSurfaceMuted.value())
            .border { color(Border.value()) }
    }
    hover {
        Modifier
            .backgroundColor(SurfaceMuted.value())
            .color(OnSurface.value())
            .border { color(BorderStrong.value()) }
    }
}

val WebButtonBareStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Transparent.value())
            .color(OnSurfaceMuted.value())
    }
    hover {
        Modifier
            .backgroundColor(SurfaceMuted.value())
            .color(OnSurface.value())
    }
}

val WebButtonOkStyle = WebButtonBaseStyle.extendedBy {
    base {
        Modifier
            .backgroundColor(Transparent.value())
            .color(Success.value())
            .border { color(Border.value()) }
    }
    hover {
        Modifier
            .backgroundColor(SuccessSoft.value())
            .border { color(Success.value()) }
    }
}

private fun WebButtonVariant.style(): CssStyle<GeneralKind> = when (this) {
    WebButtonVariant.Primary -> WebButtonPrimaryStyle
    WebButtonVariant.Brand -> WebButtonBrandStyle
    WebButtonVariant.Secondary -> WebButtonSecondaryStyle
    WebButtonVariant.Outline -> WebButtonOutlineStyle
    WebButtonVariant.Destructive -> WebButtonDestructiveStyle
    WebButtonVariant.Ghost -> WebButtonGhostStyle
    WebButtonVariant.Bare -> WebButtonBareStyle
    WebButtonVariant.Ok -> WebButtonOkStyle
}

private fun WebButtonVariant.spinnerColor(): CSSColorValue = when (this) {
    WebButtonVariant.Primary -> OnActionAccent.value()
    WebButtonVariant.Brand -> OnBrandActionAccent.value()
    WebButtonVariant.Secondary, WebButtonVariant.Outline -> OnSurface.value()
    WebButtonVariant.Destructive -> Danger.value()
    WebButtonVariant.Ghost, WebButtonVariant.Bare -> OnSurfaceMuted.value()
    WebButtonVariant.Ok -> Success.value()
}

private data class WebButtonMetrics(
    val padV: CSSLengthNumericValue,
    val padH: CSSLengthNumericValue,
    val font: CSSLengthNumericValue,
    val icon: Int,
    val spinner: CSSLengthNumericValue,
)

private fun WebButtonSize.metrics(): WebButtonMetrics = when (this) {
    WebButtonSize.SM -> WebButtonMetrics(
        ButtonSmPadV.value(),
        ButtonSmPadH.value(),
        ButtonSmType.value(),
        WebIconSize.Sm,
        ButtonSmSpinner.value(),
    )
    WebButtonSize.MD -> WebButtonMetrics(
        ButtonMdPadV.value(),
        ButtonMdPadH.value(),
        ButtonMdType.value(),
        WebIconSize.Md,
        ButtonMdSpinner.value(),
    )
    WebButtonSize.LG -> WebButtonMetrics(
        ButtonLgPadV.value(),
        ButtonLgPadH.value(),
        ButtonLgType.value(),
        WebIconSize.Lg,
        ButtonLgSpinner.value(),
    )
}

val WebSpinnerStyle = CssStyle.base {
    Modifier
        .borderRadius(RadiusButton.value())
        .border(WebSize.P2.value(), LineStyle.Solid, Transparent.value())
        .animation(
            Animation.of(
                name = AnimNames.Spin,
                duration = Dur.Spin,
                timingFunction = Ease.Linear,
                iterationCount = AnimationIterationCount.Infinite,
            )
        )
}

@Composable
fun WebButton(
    label: String,
    onClick: () -> Unit,
    variant: WebButtonVariant = WebButtonVariant.Primary,
    size: WebButtonSize = WebButtonSize.MD,
    enabled: Boolean = true,
    loading: Boolean = false,
    fillWidth: Boolean = false,
    leadingContent: (@Composable () -> Unit)? = null,
    leadingIcon: WebIcon? = null,
    ariaLabel: String? = null,
    radius: String? = null,
    classNames: List<String> = emptyList(),
) {
    val metrics = size.metrics()
    Button(
        attrs = variant.style().toAttrs<AttrsScope<HTMLButtonElement>> {
            attr("type", "button")
            classes("hp-web-button")
            classNames.forEach { classes(it) }
            ariaLabel?.let { attr("aria-label", it) }
            onClick { if (enabled && !loading) onClick() }
            if (!enabled || loading) disabled()
            style {
                padding(metrics.padV, metrics.padH)
                fontSize(metrics.font)
                if (fillWidth) property("width", "100%")
                radius?.let { property("border-radius", it) }
            }
        }
    ) {
        if (loading) {
            Span(
                attrs = WebSpinnerStyle.toModifier()
                    .width(metrics.spinner)
                    .height(metrics.spinner)
                    .borderTop(WebSize.P2.value(), LineStyle.Solid, variant.spinnerColor())
                    .toAttrs()
            ) {}
        } else {
            leadingContent?.invoke()
            if (leadingContent == null) leadingIcon?.let { Icon(icon = it, size = metrics.icon) }
            Text(label)
        }
    }
}
